import React, { FC, useState } from 'react'
import { Button, Flex, Typography } from 'antd'
import { PlayCircleOutlined } from '@ant-design/icons'
import { ModuleExampleExerciseDto } from '../../../../../shared/types/api'


const { Text } = Typography

interface AudioPlayerProps {
    ex: ModuleExampleExerciseDto,
}

export const CourseExample: FC<AudioPlayerProps> = ({ ex }) => {

    const [showTranslate, setShowtranslate] = useState<boolean>(false)


    return (
        <>
            <Text>{ex.data.title}</Text>
            <Flex style={{ marginTop: 8 }} align={'center'} gap={16}>
                <Flex style={{ marginTop: 18 }} vertical={true} gap={8}>
                    <Text>{ex.data.text}</Text>
                    {ex.data.description &&
                    !showTranslate ? <a onClick={() => setShowtranslate(true)}>Показать</a> :
                        <Text>{ex.data.description}</Text>}
                </Flex>
            </Flex>
        </>
    )
}

